/**
 * Persistência de token usando localStorage + cookie como fallback.
 * Chaves prefixadas pelo slug do tenant para isolar sessões entre estabelecimentos no mesmo navegador.
 */

import { getTenantSlug } from "./tenantScope";

const TOKEN_KEY_BASE = 'token';
const COOKIE_MAX_AGE = 90 * 24 * 60 * 60; // 90 dias em segundos

function _keys() {
  const slug = getTenantSlug();
  return {
    ls: `${slug}:${TOKEN_KEY_BASE}`,
    cookie: `${slug}__${TOKEN_KEY_BASE}`,
    legacyLs: TOKEN_KEY_BASE,
    legacyCookie: TOKEN_KEY_BASE,
  };
}

function setCookie(name, value, maxAge) {
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${maxAge};SameSite=Lax`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function deleteCookie(name) {
  document.cookie = `${name}=;path=/;max-age=0`;
}

export function saveToken(token) {
  const k = _keys();
  localStorage.setItem(k.ls, token);
  setCookie(k.cookie, token, COOKIE_MAX_AGE);
  // Mantém também na chave legada para compat com código ainda não migrado
  localStorage.setItem(k.legacyLs, token);
  setCookie(k.legacyCookie, token, COOKIE_MAX_AGE);
}

export function getToken() {
  const k = _keys();
  // 1. Tentar chave do tenant atual
  let ls = localStorage.getItem(k.ls);
  if (ls) {
    // Sincronizar chave legada para compat
    localStorage.setItem(k.legacyLs, ls);
    return ls;
  }
  let ck = getCookie(k.cookie);
  if (ck) {
    localStorage.setItem(k.ls, ck);
    localStorage.setItem(k.legacyLs, ck);
    return ck;
  }
  // 2. Fallback: chave legada (pode ser de outro tenant — deixa autenticar, backend decide se token eh valido)
  ls = localStorage.getItem(k.legacyLs);
  if (ls) return ls;
  ck = getCookie(k.legacyCookie);
  if (ck) {
    localStorage.setItem(k.legacyLs, ck);
    return ck;
  }
  return null;
}

export function removeToken() {
  const k = _keys();
  localStorage.removeItem(k.ls);
  deleteCookie(k.cookie);
  localStorage.removeItem(k.legacyLs);
  deleteCookie(k.legacyCookie);
}
